import { _match as matchResult } from './result';

/*
Este archivo es necesario porque:
- Junta los matchs de varios archivos en un solo lugar
- Genera un namespace "match" para importar en otros archivos

Nota: si se quisiera importar directamente el match de result, no se le podría colocar el namespace "match" con la funcionalidad aislada porque el namespace requiere el operador genérico de importación "* as".
*/

export const result = matchResult;
